import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
  standalone: false,
})
export class ToggleSwitchComponent {
  // label: The text to show;
  // icon: The mat-icon to show;
  // value: The value that will be send when the option is clicked
  @Input() public options: { label: string; icon?: string; value: any }[] = [];

  @Input() public actifOption: any;

  @Input() public label: string | undefined;

  @Input() public equalColumnsWidth: boolean = false;

  @Input() public isDayNight: boolean = false;

  @Input() public isMensuel: boolean = false;

  @Input() public addVacationMode: boolean = false;

  @Input() public disabled: boolean = false;

  @Input() public simpleOnOff: boolean = false;

  @Input() public light: boolean = false;

  @Output() public onOptionClick = new EventEmitter<string>();

  constructor() {}

  optionClickHandler(option: string) {
    if (!this.disabled) {
      this.onOptionClick.emit(option);
    }
  }

  optionClickHandlerSimple() {
    if (!this.disabled) {
      this.onOptionClick.emit();
    }
  }

  public get isOff(): boolean {
    if (this.simpleOnOff) {
      if (!this.actifOption) {
        return true;
      }
    } else {
      if (this.actifOption === this.options[0].value) {
        return true;
      }
    }
    return false;
  }

  public get isOn(): boolean {
    if (this.simpleOnOff) {
      if (this.actifOption) {
        return true;
      }
    } else {
      if (this.actifOption === this.options[1].value) {
        return true;
      }
    }
    return false;
  }
}
